"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecHandleSchema = exports.SPEC_HANDLE_PATTERN = exports.SPEC_HANDLE_MAX_LENGTH = void 0;
exports.normalizeSpecHandle = normalizeSpecHandle;
const z = require("zod");
exports.SPEC_HANDLE_MAX_LENGTH = 64;
exports.SPEC_HANDLE_PATTERN = /^[a-z][a-z0-9_]*$/;
function normalizeSpecHandle(raw) {
    return raw
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '');
}
exports.SpecHandleSchema = z
    .string()
    .transform(normalizeSpecHandle)
    .refine((handle) => exports.SPEC_HANDLE_PATTERN.test(handle), {
    message: 'A handle must start with a letter and contain only lowercase letters, digits, and underscores.',
})
    .refine((handle) => handle.length <= exports.SPEC_HANDLE_MAX_LENGTH, {
    message: `A handle must be at most ${exports.SPEC_HANDLE_MAX_LENGTH} characters long.`,
});
//# sourceMappingURL=spec-handle.js.map